import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BackWhite from "../../img/back-white.png";
import { calcularEdad } from "../../helpers/persona";
import {
  setModoApp,
  setPacienteSesion,
} from "../../redux/sesion/sesionActions";
import { useToasts } from "react-toast-notifications";
import { newOdontograma } from "../../redux/odontograma/odontogramaActions";
import { newPaciente } from "../../redux/paciente/pacienteActions";
import { BuscarPacientes } from "../BuscarPacientes/index";
import { ConfirmacionSiNoModal } from "../ConfirmacionSiNoModal/index";
import { newPrestations } from "../../redux/prestations/prestationsActions";
import { newCuenta } from "../../redux/cuenta/cuentaActions";
import {
  newPrestation,
  addTratamiento,
} from "../../redux/prestation/prestationActions";
import { HeaderBar, HeaderWrapper, LinkDatos, AttendanceStatus } from "./styles";
import ResponsiveButton from "../ResponsiveButton";
import Allergies from "../Allergies";
import { closeAtencionActiva, startAtencionActiva } from "../../redux/atenciones/atencionesActions";


const DatosPaciente = () => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const paciente = useSelector((state) => state.paciente);
  const cuenta = useSelector((state) => state.cuenta);
  const sesion = useSelector((state) => state.sesion);
  const [modalSalirPacienteIsOpen, setModalSalirPacienteIsOpen] = useState(false);
  const handleClick = (e) => {
    const modo = e.target.value;
    dispatch(setModoApp(modo));
    //dispatch(newPrestation());
  };
  const history = useHistory();

  const atencionActiva = useSelector(state => state.atenciones.atencionActiva);

  const handleSesionPaciente = () => {
    if (atencionActiva) {
      setModalSalirPacienteIsOpen(true);
    } else {
      onConfirmSalirPaciente();
    }
  };

  const onConfirmSalirPaciente = () => {
    setModalSalirPacienteIsOpen(false);
    dispatch(setPacienteSesion(false));
    dispatch(newPaciente());
    dispatch(newOdontograma());
    dispatch(newPrestation());
    dispatch(newPrestations());
    dispatch(newCuenta());
  };

  // Función auxiliar para formatear moneda
  const formatCurrency = (value) => {
    if (value === undefined || value === null) {
      return '0.00';
    }
    return value.toFixed(2);
  };

  const allergies = () => {
    // Verificar si patologias existe antes de usar filter
    if (!paciente || !paciente.patologias) {
      return []; // Devolver un array vacío si no hay patologías
    }

    let alergias = paciente.patologias.filter(
      (patologia) => patologia.tipo === "ALERGIA"
    );
    return alergias;
  };

  // Verificar si paciente tiene fecha de nacimiento antes de calcular edad
  const getEdad = () => {
    if (!paciente || !paciente.fecNac) {
      return '';
    }
    return `(${calcularEdad(paciente.fecNac)} años)`;
  };

  const isAttendanceActive = atencionActiva && atencionActiva.pacienteId === paciente.id;

  return (
    <HeaderWrapper isActive={isAttendanceActive}>
      <figure>
        <img
          className="header-icon"
          onClick={handleSesionPaciente}
          alt="step back icon"
          src={BackWhite}
        />
      </figure>
      <div className="header">
        <div className="header__user-data">
          <figure className="header__user-data__figure">
            <Link to="/paciente/datos">
              <img
                className="header__user-data__figure__img"
                src="https://www.kindpng.com/picc/m/495-4952535_create-digital-profile-icon-blue-user-profile-icon.png"
                alt="user profile"
              />
            </Link>
          </figure>

          <div className="header__user-data__data">
            <h3 className="header__user-data__data__name">
              <LinkDatos to="/paciente/datos">
                {paciente?.nombres || ''} {paciente?.apellidos || ''}
              </LinkDatos>
              <div className="header__user-data__data__name__span">
                <span> {getEdad()}</span>
                {atencionActiva && atencionActiva.pacienteId === paciente.id ? (
                  <div
                    style={{ display: 'flex', gap: '8px', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => history.push("/paciente/atencion")}
                  >
                    <AttendanceStatus isActive={true}>
                      ATENCIÓN EN CURSO
                    </AttendanceStatus>
                  </div>
                ) : (
                  <div
                    style={{ display: 'flex', gap: '8px', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => history.push("/paciente/atencion")}
                  >
                    <AttendanceStatus isActive={false}>
                      ATENDER
                    </AttendanceStatus>
                  </div>
                )}
              </div>
            </h3>
            <div className="header__user-data__data__socials">
              <div className="header__user-data__data__socials__item">
                <ResponsiveButton
                  iconName="whatsapp"
                  data={paciente?.telefono}
                  patientFullName={`${paciente?.nombres || ''} ${paciente?.apellidos || ''}`}
                />
              </div>

              <div className="header__user-data__data__socials__item">
                <ResponsiveButton iconName="phone" data={paciente?.telefono} />
              </div>

              <div className="header__user-data__data__socials__item">
                <ResponsiveButton
                  iconName="mail"
                  data={paciente?.correo}
                  left={true}
                />
              </div>

              <div className="header__user-data__data__socials__item">
                <ResponsiveButton
                  iconName="dni"
                  data={paciente?.numDoc}
                  left={true}
                />
              </div>
            </div>
          </div>
        </div>

        {allergies().length > 0 ? <Allergies allergies={allergies()} /> : null}

        <div className="header__balances">
          <Link to="/paciente/abonos">
            <div className="header__balances__balance">
              <p className="header__balances__balance__title">Disponible</p>
              <p>S./{cuenta?.saldo?.toFixed(2)}</p>
            </div>
          </Link>
          <Link to="/paciente/pagos">
            <div className="header__balances__balance">
              <p className="header__balances__balance__title">Deuda</p>
              <p className="header__balances__balance__debt">
                S./{cuenta?.adeudado?.toFixed(2)}
              </p>
            </div>
          </Link>
        </div>
        <ConfirmacionSiNoModal
          isOpen={modalSalirPacienteIsOpen}
          handleCloseModal={() => setModalSalirPacienteIsOpen(false)}
          mensaje="Hay una atención activa. Si sale, la atención seguirá abierta. ¿Desea continuar?"
          onClickYes={onConfirmSalirPaciente}
        />
      </div>
    </HeaderWrapper >
  );
};

export const HeaderPaciente = () => {
  const sesion = useSelector((state) => state.sesion);
  const atencionActiva = useSelector(state => state.atenciones.atencionActiva);
  const paciente = useSelector(state => state.paciente);

  const isAttendanceActive = atencionActiva && atencionActiva.pacienteId === paciente.id;

  if (sesion.paciente)
    return (
      <>
        <HeaderBar isActive={isAttendanceActive}>
          <DatosPaciente />
        </HeaderBar>
      </>
    );
  else
    return (
      <>
        <HeaderBar>
          <BuscarPacientes />
        </HeaderBar>
      </>
    );
};